import Api from './Api'

export const attivitaApi = {
  heartbeat: () => Api.post('/attivita/heartbeat'),
  utenti: (da, a) => Api.get('/attivita/utenti', { da, a }),
  giornata: giorno => Api.get('/attivita/giornata', { giorno }),
  intraday: userId => Api.get('/attivita/intraday', { userId }),
  storico: ({ granularita, da, a, userId }) => Api.get('/attivita/storico', { granularita, da, a, userId }),
  cronologia: (userId, params = {}) => Api.get(`/attivita/cronologia/${userId}`, typeof params === 'number' ? { offset: params } : params),
  modifiche: id => Api.get(`/attivita/azioni/${id}`)
}
